import { AuthContextInterface } from './AuthInterface';

export const authInitialState: AuthContextInterface = {
  loggedUser: undefined,
  firebaseUser: null,
};
